<template>
  <v-container>
    <div v-if="alerta">
      <alert-empty></alert-empty>
    </div>
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Planificacion de Retorno</v-toolbar-title
          >
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <grid-planificacion
          :key="planificacionGrid"
          :contratoId="contratoId"
        ></grid-planificacion>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import GridPlanificacion from "./GridPlanificacion.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import axios from "axios";

export default {
  name: "cronograma-ca-co",
  components: {
    GridPlanificacion,
    AlertEmpty,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      contratoId: "",
      allowSpaces: false,
      valid: false,
      fechaInicioValue: null,
      fechaFinValue: null,
      fechaInicioSelect: [],
      fechaFinSelect: [],
      visitasCont: [],
      filter: false,
      planificacionGrid: 0,
      alerta: false,
      loading: false,
    };
  },
  computed: {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
    }
  },
  methods: {
    reloadPlanificacion() {
      this.planificacionGrid += 1;
    },
  },
};
</script>
